import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import Group from 'components/utils/Group'
import Caption from 'LuxKit/Typography/Caption'
import ResponsiveLuxuryEscapesLogo from 'components/App/Header/Logo/logos/ResponsiveLuxuryEscapesLogo'
import { mediaQueryUp } from 'components/utils/breakpoint'

const Banner = styled.div`
  background: ${(props) => props.theme.palette.neutral.default.one};
  padding: ${rem(8)} ${rem(20)};
`

const LogoWrapper = styled.div`
  display: flex;
  height: ${rem(14)};

  svg {
    height: 100%;
    width: auto;
  }

  ${mediaQueryUp.desktop} {
    height: ${rem(16)};
  }
`

function CorporateEventPartnershipBanner() {
  return (
    <Banner>
      <Group
        direction="horizontal"
        gap={8}
        verticalAlign="center"
        horizontalAlign="center"
      >
        <Caption variant="medium" colour="static-white">
          <FormattedMessage
            id="evyWFQYy5VM8FMP4nB0S"
            defaultMessage="Powered by"
            
          />
        </Caption>
        <LogoWrapper>
          <ResponsiveLuxuryEscapesLogo mobileVariant="icon+text" fill="white" />
        </LogoWrapper>
      </Group>
    </Banner>
  )
}

export default CorporateEventPartnershipBanner
